/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['dashboard-core/js/lib/@waca/dashboard-common/dist/utils/ObjectHelper'], (ObjectHelper) => {
	class ZoomAPI {
		/**
		 * @description Gets the current zoom ratio for the canvas.
		 * @function ZoomAPI#getZoomLevel
		 * @returns {Number} The current zoom ratio that the canvas is using.
		 */
		getZoomLevel() {}

		/**
		 * @description Sets the zoom ratio for the canvas when in absolute layout mode.
		 * @function ZoomAPI#setZoomLevel
		 * @param {Number} value - The desired zoom ratio to zoom the canvas to.
		 * @example
		 * setZoomLevel(2) // Zooms in canvas to 200%;
		 */
		setZoomLevel() {}

		/**
		 * @description Sets the zoom mode for the canvas when in absolute layout mode.
		 * @function ZoomAPI#setZoomMode
		 * @param {string} mode - The desired zoom mode the canvas should use.
		 * @example
		 * setZoomMode('fitPage') // Automatically zooms in canvas to fit the page;
		 * setZoomMode('fitWidth') // Automatically zooms in canvas to fit the width of the page;
		 * setZoomMode('manual') // Zoom is adjusted manually;
		 */
		setZoomMode() {}

		/**
		 * @description Gets the zoom mode for the canvas when in absolute layout mode.
		 * @function ZoomAPI#getZoomMode
		 * @returns {string} the current zoom mode.
		 */
		getZoomMode() {}

		/**
		 * @description Registers an event handler on the zoom feature.
		 * @function ZoomAPI#on
		 * @param {String} name Event name
		 * @param {Function} handler Event handler
		 * @return {Object} Object that has a remove function to remove the event handler.
		 * @example
		 * dashboard.getFeature('Zoom').on('change:changeZoom', (event) => { console.log(event.info.events); });
		 */
		on() {}

		/**
		 * @description Deregisters an event handler for the zoom feature.
		 * @function ZoomAPI#off
		 * @public
		 *
		 * @param {String} name Event name
		 * @param {Function} name Event handler
		 *
		 */
		off() {}
	}

	/**
	 * @public
	 * @readonly
	 * @enum {string}
	 * @memberof ZoomAPI
	 */
	ZoomAPI.ZOOM_MODES = ObjectHelper.deepFreezeObject({
		/** Fit to page mode.<br>
		Zoom level will automatically adjust to fit all content within the window. */
		FIT_PAGE: 'fitPage',
		/** Fit to width mode.<br>
		Zoom level will automatically adjust to fit all content within the width of the window. */
		FIT_WIDTH: 'fitWidth',
		/** Manual mode.<br>
		Zoom level will not be automatically adjusted. */
		MANUAL: 'manual'
	});

	return ZoomAPI;
});